module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/signature2021-3069032e22800736f2671835c81ced0c.png";